<form novalidate (ngSubmit)="submit()" [formGroup]="form">
  <ion-list>
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-item>
            <div style="width: 100%; display: flex; justify-content: space-between;">
              <ion-select style="padding-left: 0px;" [interfaceOptions]="{ cssClass: 'select-alert' }" [(ngModel)]="currentStreet" placeholder="{{ 'Address.Street' | translate }}"
                [ngModelOptions]="{standalone: true}" (ionBlur)="onStreetClose()" (ionChange)="onStreetUpdated()" #streetSelect>
                @for (s of partialAddresses; track s) {
                  <ion-select-option [value]="s">{{ formatStreet(s) }}</ion-select-option>
                }
                <ion-select-option [value]="null">{{ 'Address.CantFindStreet' | translate }}</ion-select-option>
              </ion-select>
              <ion-button [ngStyle]="!useCustomAddress && {'display': 'none'}" color="light" (click)="openStreetSelect()">{{ 'Address.Change' | translate }}</ion-button>
            </div>
          </ion-item>
        </ion-col>
      </ion-row>

      @if (useCustomAddress) {
        <ion-row>
          <ion-col size="12">
            <ion-item class="input-street-row">
              <ion-label position="floating">
                {{ 'Address.StreetAddress' | translate }}
              </ion-label>
              <ion-input formControlName="streetAddress" type="text" (ionChange)="toUpperCase()"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      }

      @if (useCustomAddress) {
        <ion-row>
          <ion-col size="12">
            <ion-item>
              <ion-label position="floating">
                {{ 'Address.City' | translate }}
                @if (formErrors.has('city')) {
                  <span color="danger"><br />{{formErrors.get('city')}}</span>
                }
              </ion-label>
              <ion-input formControlName="city" type="text"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      }

      @if (currentStreet) {
        <ion-row>
          <ion-col size="4">
            <ion-item>
              <ion-label position="floating">
                {{ 'Address.City' | translate }}
                @if (formErrors.has('city')) {
                  <span color="danger"><br />{{formErrors.get('city')}}</span>
                }
              </ion-label>
              <ion-input formControlName="city" type="text"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="4">
            <ion-item>
              <ion-label position="floating">
                {{ 'Address.StreetDirection' | translate }}
                @if (formErrors.has('streetDirection')) {
                  <span
                  color="danger"><br />{{formErrors.get('streetDirection')}}</span>
                }
              </ion-label>
              <ion-input formControlName="streetDirection" type="text"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="4">
            <ion-item>
              <ion-label position="floating">
                {{ 'Address.StreetType' | translate }}
                @if (formErrors.has('StreetType')) {
                  <span color="danger"><br />{{formErrors.get('StreetType')}}</span>
                }
              </ion-label>
              <ion-input formControlName="streetType" type="text"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      }

      @if (currentStreet) {
        <ion-row >
          <ion-col size="6">
            <ion-item>
              <ion-label position="floating">
                {{ 'Address.StreetNumber' | translate }}
                @if (formErrors.has('StreetNumber')) {
                  <span color="danger"><br />{{formErrors.get('StreetNumber')}}</span>
                }
              </ion-label>
              <ion-input formControlName="streetNumber" type="number"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="6">
            <ion-item>
              <ion-label position="floating">
                {{ 'Address.SuiteNumber' | translate }}
                @if (formErrors.has('SuiteNumber')) {
                  <span color="danger"><br />{{formErrors.get('SuiteNumber')}}</span>
                }
              </ion-label>
              <ion-input formControlName="suiteNumber" type="text"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      }

    </ion-grid>
  </ion-list>

  @if (currentStreet || useCustomAddress) {
    <div class="ion-padding">
      <ion-button type="submit" [disabled]="!form.valid && !useCustomAddress" color="primary" expand="block">
        {{ 'General.Validate' | translate }}
      </ion-button>
    </div>
  }
</form>

<ng-template #addressConfirmationDialog>
  <mat-dialog-content style="margin-top: -12px;" class="dialog-content">
    <h6><b>{{ 'Address.AddressEntered' | translate }}:</b></h6>
    <div style="background-color: #fffbd0; margin: 0 -24px;">
      <h6 style="margin: 12px 0 5px 24px; padding-top: 6px;">{{customAddressModel.streetNumber}} {{customAddressModel.street}}</h6>
      <h6 style="margin: 0 0 0 24px; padding-bottom: 6px;">{{customAddressModel.city}} {{customAddressModel.province}} {{customAddressModel.postalCode}}</h6>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button matDialogClose color="primary" class="dialog-btn-margin" (click)="confirmAddress()"> {{ 'General.Confirm' | translate }}</button>
    <button mat-button matDialogClose color="primary" class="dialog-btn-margin"> {{ 'General.Cancel' | translate }}</button>
  </mat-dialog-actions>
</ng-template>